import Vue from "vue";
export var NoteAttachmentEventBus = new Vue();